
































































import {Vue, Component, Watch, Prop} from 'vue-property-decorator';
import {Utils} from '@/utils/Utils';
import {mapGetters} from 'vuex';
import DashboardDataFooter from '@/components/DashboardDataFooter.vue';

@Component({
  components: {
    DashboardDataFooter,
  },

  computed: {...mapGetters(['shipList'])},
})
export default class DashboardTableComponent extends Vue {
  @Prop() inspectionListData!: any;
  @Prop() type: String;
  Utils = Utils;
  shipId = null;

  startingPoint = 0; //pagination starting point
  endingPoint = 5; //pagination ending point

  //table header
  header = [
    {
      name: 'Inspection ID',
      value: 'inspectionCode',
      sortable: true,
      headerType: 'text',
      asdcOrder: true,
      filter: true,
    },
    {
      name: '#',
      value: 'totalInspections',
      sortable: true,
      headerType: 'number',
      asdcOrder: true,
      filter: true,
    },
    {
      name: 'Ship',
      value: 'shipName',
      sortable: true,
      headerType: 'text',
      asdcOrder: true,
      filter: true,
    },
    {
      name: 'Deck',
      value: 'deckName',
      sortable: true,
      headerType: 'text',
      asdcOrder: true,
      filter: true,
    },

    {
      name: 'Created',
      value: 'inspectionDate',
      sortable: true,
      headerType: 'date',
      asdcOrder: true,
      filter: true,
    },
  ];

  curentSort = '';
  asdcOrder = true;
  showNoOfInspection = false;

  //sort data based in column
  clickOnSort(header: any) {
    if (this.curentSort !== header.value) {
      this.curentSort = header.value;
      this.asdcOrder = true;
    }
    let sorted = Utils.sortData(this.asdcOrder, header, this.inspectionListData);
    this.asdcOrder = sorted;
  }

  //render records based on pagination
  onPaginitionValueChange(startingPoint: number, endingPoint: number) {
    this.startingPoint = startingPoint - 1;
    this.endingPoint = endingPoint;
  }

  //get dynamic header based upon table type
  getHeader() {
    if (this.type === 'actionplan') {
      return this.header.filter((head) => (head.name !== '#' ? true : false));
    } else {
      return this.header;
    }
  }

  // calling function in parent on month change
  onMonthDurationChange(param) {
    this.$emit('onMonthDurationChange', param);
  }

  // calling function in parent on ship change
  onShipChange(param) {
    this.$emit('onShipChange', param);
  }

  //navigate to inspectioin detail page
  navigateToPages(id) {
    this.$router.push(`/view-inspection/` + id);
  }
}
